import React, { Component } from 'react'
import {
  SvgUpload
} from '../Svg'
/**
 * 用户中心组件
 */
class Upload extends Component {
    static defaultProps = {
      data: [{
        url: '//sc.youku.com/',
        title: '上传视频',
        className: 'upload-video'
      }, {
        url: '//newvideos.youku.com/u/videos',
        title: '视频管理',
        className: 'u-creat'
      }, {
        url: '//i.youku.com/i/profile',
        title: '我的自频道',
        className: 'u-zpd'
      }, {
        url: '//mp.dayu.com/dashboard/stat/video',
        title: '数据分析',
        className: 'data-analysis'
      }],
      iconData: {
        url: '//sc.youku.com/',
        title: '上传',
        className: 'ico-upload'
      },
      bottomData: {
        url: '//pd.youku.com/pc',
        title: '立即下载',
        className: 'ikuDownload',
        text: '优酷PC客户端,看片免广告！'
      }
    }
    constructor (props) {
      super(props)
      this.state = {
        hoverClass: ''
      }
    }
    handleMouseEnter (e) {
      this.setState({
        hoverClass: 'dropdown-open'
      })
    }

    handleMouseLeave () {
      this.setState({
        hoverClass: ''
      })
    }
    render () {
      return (
        <div className='u-upload'
          onMouseEnter={this.handleMouseEnter.bind(this)}
          onMouseLeave={this.handleMouseLeave.bind(this)}>
          <div className={`dropdown ${this.state.hoverClass}`}>
            <div className='handle'>
              <a href={this.props.iconData.url} target='_blank' rel='noopener noreferrer'>
                <SvgUpload /><br />{this.props.iconData.title}</a>
            </div>
            <div className='panel'>
              <i className='arrow' />
              <div className='content'>
                <ul className='u-list'>
                  {
                    this.props.data.map((item, i) => {
                      return (
                        <li key={i}>
                          <a href={item.url} target='_blank' rel='noopener noreferrer' className={item.className} >
                            <em /> {item.title} </a>
                        </li>)
                    })
                  }
                </ul>
              </div>
              <div className='u-bottom'>
                <a href={this.props.bottomData.url} className={this.props.bottomData.className}
                  target='_blank'><i />{this.props.bottomData.title} </a>{this.props.bottomData.text}
              </div>
            </div>
          </div>
        </div>
      )
    }
}
export default Upload
